import { NavLink } from "react-router-dom";

const ModalBannerContent = props => {
    return (
        <div class="modal-content modal-banner">
			<a href={props.link} onClick={props.onClose}>
				<img src={props.imgSrc} />
			</a>
			<div class="modal-banner-control">
				<label class="checkbox" onClick={e => props.onClose(e, true)}>
					<input type="checkbox"  />
					<span>24시간 동안 다시 열람하지 않기</span>
				</label>
				<button type="button" onClick={props.onClose}>
					<span>닫기</span>
				</button>
			</div>
		</div>
    )
}

const ModalBase = props => {
    const isBanner = props.isBanner || false;
    return (
        <div className="modal-dialog open">
            <div className="dim" onClick={props.onClose}></div>
            {isBanner 
                ? <ModalBannerContent {...props} />
                : <div className="modal-content">
                    <div class="modal-header">
                        <h1>{props.title}</h1>
                        <button type="button" class="modal-close" onClick={props.onClose}>
                            <i class="icon icon-close"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        {props.children}
                    </div>
                </div>
            }
        </div>
    )
}

export default ModalBase;